export enum PaymentGatewayName {
    BILLWERK = 'billwerk',
    STRIPE = 'stripe',
    CREDIT = 'credit',
    IOS = 'ios',
    ANDROID = 'android',
}

export enum ContractStatus {
    ACTIVE = 'contract_active',
    ENDING = 'contract_ending',
    ENDED = 'contract_ended',
    EMPTY = 'no_previous_contract',
}

export enum PaymentMethod {
    CREDITS = 'Credits',
}

export enum GuestUploadPaymentMethod {
    PAYPAL = 1,
    WISE = 2,
    OVO = 3,
}
